import { render } from "./MediaGalleryButton.vue?vue&type=template&id=5db10126&scoped=true"
import script from "./MediaGalleryButton.vue?vue&type=script&lang=js"
export * from "./MediaGalleryButton.vue?vue&type=script&lang=js"

import "./MediaGalleryButton.vue?vue&type=style&index=0&id=5db10126&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5db10126"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QBar from 'quasar/src/components/bar/QBar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QImg from 'quasar/src/components/img/QImg.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn,QChip,QTooltip,QDialog,QSpinner,QCard,QBar,QIcon,QSpace,QCardSection,QImg});qInstall(script, 'directives', {ClosePopup});
